import React from "react";

const Footer: React.FC = () => {
    return (
        <footer className="footer footer-transparent d-print-none">
            <div className="container-fluid">
                <div className="row text-center align-items-center flex-row-reverse">
                    <div className="col-12 col-lg-auto mt-3 mt-lg-0">
                        <ul className="list-inline list-inline-dots mb-0">
                            <li className="list-inline-item">
                                Copyright &copy; 2024
                                <a href="." className="link-secondary mx-1">Djitu</a>.
                                All rights reserved.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;